import * as tslib_1 from "tslib";
import { TaskStatus, } from '@models';
import { JobTriggerBaseComponent } from '@pages/jobs/grids/job-triggers';
import { TaskService } from '@services';
var JobTriggerTaskComponent = /** @class */ (function (_super) {
    tslib_1.__extends(JobTriggerTaskComponent, _super);
    function JobTriggerTaskComponent(_taskService) {
        var _this = _super.call(this) || this;
        _this._taskService = _taskService;
        _this.TaskStatus = TaskStatus;
        _this._fetchItem = function () { return _this._taskService.getInstance(_this._itemId, ['AssignedToUser']); };
        return _this;
    }
    return JobTriggerTaskComponent;
}(JobTriggerBaseComponent));
export { JobTriggerTaskComponent };
